import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, ChangeDetectorRef, NgZone } from '@angular/core';
import { ProposalService } from 'src/app/services/proposal/proposal.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
// import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { MainService } from 'src/app/services/main-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { ToasterService } from 'src/app/services/toaster.service';
declare const Stripe: any;
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit, AfterViewInit {
  public cardMask: any = [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];
  public cardYearMask: any = [/\d/, /\d/];
  public cardDateMask: any = [/[0-3]/, /\d/];
  public cardCVVMask: any = [/\d/, /\d/, /\d/, /\d/];
  cardName: any;
  cardError: any;
  cardNumber: any;
  cardMonth: any;
  cardYear: any;
  cardCVV: any;
  saveCard: any;
  billAddress: any;
  downAddress: any;
  downLine2Address: any;
  zip: any;
  state: any;
  city: any;
  zips: any[] = [];
  patientData: any = {
    payment_sources: [],
    recurring_payment_sources: []
  };
  financeData: any = {};
  settingsData: any = {};
  patient_stripe_token: any;
  patient_new_stripe_token: any;
  patient_recurring_stripe_token: any;
  patient_new_recurring_stripe_token: any;
  patient: any;
  months: any = [];
  newYears: any = [];
  dates: any = [];
  dob: any = {
    month: '',
    date: '',
    year: '',
  };
  dateObject: any;
  terms: boolean;
  consent: boolean;
  selectedCardIndex: number;
  minDate: Date;
  maxDate: Date;
  recurringDate: any;
  colorTheme = 'theme-blue';
  signature: any;
  signatureUrl: any;
  loader: boolean;
  errorMessage: any;
  queryParams: any;
  token: any;
  add_pf_success: number = 0;
  bsConfig: Partial < BsDatepickerConfig > ;
  hitInProgress: boolean = false;
  LABEL: any;
  contract_type:any;
  public signaturePadOptions: Object = {
    'minWidth': 2,
    'canvasWidth': 600,
    'canvasHeight': 300
  };
  // @ViewChild(SignaturePad) signaturePad: SignaturePad;
  @ViewChild('addCardModal') public addCardModal: ModalDirective;
  @ViewChild('addRecurringCardModal') public addRecurringCardModal: ModalDirective;
  @ViewChild('askRecurringCardModal') public askRecurringCardModal: ModalDirective;
  buttonClickedSubject: Subject<any> = new Subject();
  constructor(public proposal: ProposalService, public mainService: MainService, public router: Router,
    public route: ActivatedRoute, private datePipe: DatePipe, public toasterService: ToasterService, public cd: ChangeDetectorRef, private ngZone: NgZone) {
    this.terms = false;
    this.consent = false;
    this.mainService.setLoader(false);
    this.LABEL = this.mainService.LABEL;
    this.bsConfig = Object.assign({}, {
      containerClass: this.colorTheme,
      showWeekNumbers: false,
      dateInputFormat: 'MM/dd/yyyy'
    });
    this.proposal.getData().subscribe((data: any) => {
      this.patientData = data.patients[0];
      this.financeData = data.financing_info[0];
      this.setTransactionData();
      // if (!this.patientData.patient_first_name) {
      if (sessionStorage.getItem('patientData')) {
        this.patientData = JSON.parse(sessionStorage.getItem('patientData'));
        // }
      }

      const tempStart = (this.financeData.start_date.split('T'));
      const tempEnd = (this.financeData.end_date.split('T'));

      this.patientData.recurring_payment_sources = this.patientData.payment_sources;
      // console.log(this.financeData.start_date);
      // console.log(new Date(this.financeData.start_date));
      // console.log(tempStart[0]);
      // console.log(tempEnd[0]);
      const tempStartDate = tempStart[0].split('-');
      const sYY = tempStartDate[0];
      const sMM = tempStartDate[1];
      const sDD = tempStartDate[2];

      const tempEndDate = tempEnd[0].split('-');
      const eYY = tempEndDate[0];
      const eMM = tempEndDate[1];
      const eDD = tempEndDate[2];


      console.log(sYY, sMM, sDD)
      this.minDate = new Date(sYY, sMM - 1, sDD, 0, 0, 0, 0);
      this.maxDate = new Date(eYY, eMM - 1, eDD, 0, 0, 0, 0);
      // console.log(this.minDate);
      // console.log(this.maxDate);
    });
    this.mainService.getMsg().subscribe((data: any) => {
      this.settingsData = data;
      // Stripe.setPublishableKey(data.stripe_pk);
      // console.log(this.settingsData);
    });

    if (sessionStorage.getItem('contractType')) {
      this.contract_type = JSON.parse(sessionStorage.getItem('contractType'));
    }
    
    this.token = this.proposal.getToken();
    this.cd.markForCheck();
    // //console.log(this.token);
  }

  @ViewChild('canvasDiv')
  canvasDiv: ElementRef < any > ;
  setTransactionData() {
    if (this.financeData && this.financeData.enrollment_enabled) {
      this.financeData.fixed_flat_fee = 0
    } else {
      this.financeData.fixed_flat_fee = 30
    }
    this.financeData.transaction_fee = this.mainService.getCalculatedTransactionFee(this.financeData,this.financeData.downpayment_amount) + this.mainService.getCalculatedTransactionFee(this.financeData,this.financeData.advance_interest_amount);
    this.financeData.payable_amount_today = parseFloat(this.financeData.downpayment_amount) + parseFloat(this.financeData.advance_interest_amount) + parseFloat(this.financeData.fixed_flat_fee) + this.financeData.transaction_fee
  }

  ngAfterViewInit() {
    // console.log(this.canvasDiv.nativeElement.offsetWidth);
    // console.log(this.canvasDiv.nativeElement.offsetHeight);
    // this.signaturePad.set('canvasWidth', this.canvasDiv.nativeElement.offsetWidth);
    // this.signaturePad.set('canvasHeight', this.canvasDiv.nativeElement.offsetHeight);
    // this.signaturePad.clear();
  }
  ngOnInit() {
    this.proposal.getPatientUpdatedData().subscribe((data: any) => {
      this.patient = data;
      // console.log(this.patient);
      this.patientData = this.patient.personal;
      this.patientData.recurring_payment_sources = this.patientData.payment_sources;
      // console.log(this.patientData.recurring_payment_sources);
      this.financeData = this.patient.finance;
      this.setTransactionData();
      // if (!this.patientData.patient_first_name) {
      if (sessionStorage.getItem('patientData')) {
        this.patientData = JSON.parse(sessionStorage.getItem('patientData'));
      }
      // }
    });
  }
  clearSign() {
    // this.signaturePad.clear();
    this.signature = '';
  }
  drawComplete(dataUrl: string) {
    if (!dataUrl) {
      this.signatureUrl = '';
      this.signature = '';
      return;
    }
    // will be notified of szimek/signature_pad's onEnd event
    // //console.log(this.signaturePad.toDataURL());
    this.signatureUrl = dataUrl;
    const dataURI = this.signatureUrl;
    const byteString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], {
      type: 'image/jpeg'
    });
    this.signature = blob;
    // this.toasterService.message('success', 'Signature registered successfully', '');
  }

  selectCard(data: any, i: number) {
    this.selectedCardIndex = i;
    this.patient_stripe_token = data.source_id;
    this.patient_new_stripe_token = '';
    // this.askRecurringCard();
  }

  askRecurringCard() {
    this.removeValues();
    this.askRecurringCardModal.show();
  }
  resetRecurringModal() {
    this.askRecurringCardModal.hide();
    this.billAddress = true;
    setTimeout(() => {
      this.removeValues();
      this.addRecurringCardModal.show();
      this.GetStripeToken('clear')
    }, 100);
  }
  // Yes on same recurring and down payment
  downPaymentAsRecurring() {
    this.submitPatientData('', 1);
  }

  // No on same recurring and down payment
  selectRecurringCard(data: any) {
    this.patient_recurring_stripe_token = data.source_id;
    this.patient_new_recurring_stripe_token = '';
    this.submitPatientData(this.patient_recurring_stripe_token, 0);
  }
  addRecurringAPI(recurring_token: any) {
    const params = {
      'contract_token': this.token,
      'recurring_token': recurring_token
    };
    this.mainService.setLoader(true);
    this.hitInProgress = true;
    this.proposal
      .api('post', 'add_recurring_card', this.mainService.urlParams(params))
      .subscribe(
        (data: any) => {
          this.hitInProgress = false;
          this.mainService.setLoader(false);
          //console.log(data);
          this.mainService.flagPopUps(data.flag, data.is_error);
          if (!data.is_error) {
            //console.log(data);
            this.addRecurringCardModal.hide();
            this.toasterService.message(
              'Request submitted successfully',
              1
            );
            this.router.navigate(['/thanks']);
          } else {
            this.ngZone.run(() => {
              if (data.override_text) {
                this.toasterService.message(data.override_text, 3);
              } else if (data.err) {
                this.toasterService.message(data.err, 3);
              } else {
                this.mainService.flagPopUps(data.flag, data.is_error);
              }
            });

          }
        },
        (err: any) => {
          this.mainService.setLoader(false);
          this.errorMessage = err.error;
        }
      );
  }
  selectZip(zip: any) {
    //console.log(zip);
    // this.city_id = zip.city_id;
    this.city = zip.city;
    this.state = zip.state_name;
    this.zip = zip.zip;
    this.zips = [];
  }
  getZip(token: string, type: number) {
    //console.log(token);
    if (token.length > 3) {
      this.mainService.getZipcode({
          zipcode: token
        })
        .subscribe((data: any) => {
          //console.log(data);
          if (type === 1) {
            this.zips = data;
          }
        }, (error: any) => {
          //console.log(error);
        });
    } else {
      // const b = [];
      return false;
    }
  }

  validateData() {
    if (!this.signature) {
      this.toasterService.message('Signature not registered', 2);
      return false;
    }
    if (!this.patient_stripe_token && !this.patient_new_stripe_token) {
      this.toasterService.message('Please add/select a card for your contract', 2);
      return false;
    }
    // if (!this.patient_recurring_stripe_token && !this.patient_new_recurring_stripe_token) {
    //   this.toasterService.message('warning', 'Please select a card for your contract', '');
    //   return false;
    // }
    if (!this.recurringDate) {
      this.toasterService.message('Please choose a valid start date for your contract', 2);
      return false;
    }
    if (!this.terms) {
      this.toasterService.message('Please agree to the terms & conditions for your contract', 2);
      return false;
    }
    if (!this.consent) {
      this.toasterService.message('Please agree to the consent for treatment and payment plan agreement for your contract', 2);
      return false;
    }
    this.askRecurringCard();
  }
  submitPatientData(recurringToken: any, mode: any) {

    const formData = new FormData();
    formData.append('patient_signature', this.signature);
    if (this.patient_stripe_token) {
      formData.append('source_id', this.patient_stripe_token);
    }
    if (this.patient_new_stripe_token) {
      formData.append('stripe_token', this.patient_new_stripe_token);
    }
    formData.append('payment_source_type', '3');
    formData.append('contract_token', this.token);
    formData.append('patient_email', this.patientData.patient_email);
    formData.append('start_date', this.datePipe.transform(this.recurringDate, 'yyyy/MM/dd'));
    formData.append('patient_id', this.patientData.patient_id || 0);
    formData.append('patient_first_name', this.patientData.patient_first_name);
    formData.append('patient_last_name', this.patientData.patient_last_name);
    formData.append('title', this.patientData.title !== 'None' ? this.patientData.title : '');
    formData.append('patient_mobile', this.patientData.patient_mobile_formatted);
    formData.append('patient_address', this.patientData.patient_address);
    formData.append('date_of_birth', this.datePipe.transform(this.patientData.dob, 'yyyy/MM/dd'));
    // formData.append('date_of_birth', '1993-08-23');
    formData.append('patient_gender', this.patientData.patient_gender);
    formData.append('city_id', this.patientData.city_id);
    // formData.append('patient_ssn', '123456789');
    formData.append('patient_ssn', this.patientData.patient_ssn);
    formData.append('dl_number', this.patientData.dl_number);
    formData.append('employer_name', this.patientData.employer_name);
    formData.append('employer_mobile', this.patientData.employer_mobile_formatted);
    formData.append('employer_address', this.patientData.employer_address);
    formData.append('employer_city', this.patientData.employer_city_id);
    formData.append('annual_income', this.patientData.annual_income);
    formData.append('is_minor', this.patientData.is_minor);
    if (parseInt(this.patientData.is_minor, 10) === 1) {
      formData.append(
        'guardian_title',
        this.patientData.guardian_title !== 'None' ? this.patientData.guardian_title : ''
      );
      formData.append('guardian_first_name', this.patientData.guardian_first_name);
      formData.append('guardian_last_name', this.patientData.guardian_last_name);
    }
    if (mode === 0) {
      formData.append('patient_status', '1');
    } else {
      formData.append('patient_status', '2');
    }
    this.mainService.setLoader(true);
    this.hitInProgress = true;
    this.proposal.formApi('post', 'add_pf_patient_info', formData)
      .subscribe((data: any) => {
        setTimeout(() => {
          this.hitInProgress = false;
          this.mainService.setLoader(false);
          //console.log(data);
          this.mainService.flagPopUps(data.flag, data.is_error);
          if (!data.is_error) {
            this.add_pf_success = 1;
            //console.log(data);
            this.patientData.recurring_payment_sources = data.payment_sources;
            this.patientData.payment_sources = data.payment_sources;
            for (let index = 0; index < this.patientData.payment_sources.length; index++) {
              if (this.patientData.payment_sources[index].source_id === data.apf_data[0].source_id) {
                this.selectedCardIndex = index;
                this.patient_stripe_token = this.patientData.payment_sources[index].source_id;
              }
            }

            if (mode === 0) {
              this.addRecurringAPI(recurringToken);
            } else {
              // this.addRecurringAPI(data[0].source_id);
              this.toasterService.message('Request submitted successfully', 1);
              this.mainService.setLoader(true);
              this.router.navigate(['/thanks']);
            }
            // this.toasterService.message('success', 'Request submitted successfully', '');
            // this.router.navigate(['/thanks']);
          }
          else {
            if(data.stripe_error == 1){
              this.patientData.payment_sources = [];
              this.patient_new_stripe_token = '';
              this.askRecurringCardModal.hide();

            }
            this.ngZone.run(() => {
            if (data.override_text) {
              this.toasterService.message(data.override_text, 3);
            } else if (data.err) {
              this.toasterService.message(data.err, 3);
            } else {
              this.mainService.flagPopUps(data.flag, data.is_error);
            }
            });

          }
        }, 10);
      }, (err: any) => {
        this.mainService.setLoader(false);
        //console.log(this.mainService.loader);
        this.errorMessage = err.error;
        this.toasterService.message(this.errorMessage, 3);
      });
  }
  removeValues() {
    this.zips = [];
    this.city = '';
    this.state = '';
    this.zip = '';
    this.cardName = "";
    this.cardError = "";
    this.cardNumber = "";
    this.cardMonth = "";
    this.cardYear = "";
    this.cardCVV = "";
    this.saveCard = "";
    this.billAddress = "";
    this.downAddress = "";
    this.downLine2Address = "";
  }
  GetStripeToken(button_action) {
    this.buttonClickedSubject.next(button_action);
  }
  CatchStripeToken(token_data, modal) {
    console.log(token_data, modal)
    this.patient_new_stripe_token = token_data.token.id;
    this.patient_stripe_token = '';
    this.addCardModal.hide();
    const source = {
      last4: token_data.token.card.last4,
      brand: token_data.token.card.brand
    };
    // this.patientData.recurring_payment_sources.push(source);
    this.patientData.payment_sources = [source];
    this.selectedCardIndex = 0;
    this.mainService.setLoader(false);
    this.cd.detectChanges();
  }
  CatchStripeTokenForRecursiveCard(token_data) {
    this.patient_new_recurring_stripe_token = token_data.token.id;
    this.patient_recurring_stripe_token = '';
    if (this.add_pf_success == 0) {
      this.submitPatientData(this.patient_new_recurring_stripe_token, 0);
    } else {
      this.addRecurringAPI(this.patient_new_recurring_stripe_token);
    }
  }
  RemoveStripeElement(element_id) {
    this.mainService.stripe_element.unmount('#' + element_id);
  }
  AddStripeElement(element_id) {
    setTimeout(() => {
      this.mainService.stripe_element.mount('#' + element_id);
    }, 1000);
  }

  getParentDivWidth() {
    return document.getElementById('canvasDiv').offsetWidth;
  }

}
